export default __webpack_public_path__ + "static/media/file.0dcbe82b.svg";